import { BASE_PATH } from "./basePath";

// Runtime configuration, fetched from <base>/config.json before the app boots.
//
// Create React App inlines `process.env` at build time, so nothing
// environment-specific may be read from it any more — every API endpoint, client
// id and redirect URI comes through this object instead. It is mutated in place
// so that modules importing it hold a live reference.
export const env = {};

const CONFIG_URL = `${BASE_PATH}/config.json`;

export async function loadRuntimeConfig() {
	const response = await fetch(CONFIG_URL, { cache: "no-store" });

	if (!response.ok) {
		throw new Error(`${CONFIG_URL} -> HTTP ${response.status}`);
	}

	Object.assign(env, await response.json());

	// Also exposed globally, per the EKS runtime-config SOP, and handy in devtools.
	window.APP_CONFIG = env;

	return env;
}
